import { render, staticRenderFns } from "./LogProductivity.vue?vue&type=template&id=65420535&"
import script from "./LogProductivity.vue?vue&type=script&lang=js&"
export * from "./LogProductivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports